import React from 'react'

import TooltipFix from 'components/TooltipFix'

export default class PinIcon extends React.Component {
  state = { hovered: false }

  onHover = () => {
    this.setState({ hovered: true })
  }

  onBlur = () => {
    this.setState({ hovered: false })
  }

  render() {
    const { disabled = false, isPinned, onPinClick } = this.props
    const iconClassName = isPinned
      ? 'Icon Icon-pushpin-filled'
      : 'Icon Icon-pushpin'
    return (
      <TooltipFix
        key="pin-icon"
        tooltip={isPinned ? 'Unpin search' : 'Pin search'}
        onClick={!disabled ? onPinClick : null}
        onMouseEnter={this.onHover}
        onMouseLeave={this.onBlur}
      >
        <span className={iconClassName} />
      </TooltipFix>
    )
  }
}
